import { Button } from '@mui/material';
import { isEmptyObject } from '@vy/utils';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFetchMorningSettings } from '../hooks/useFetchMorningSettings';
import { useModifyConfiguration } from '../hooks/useModifyConfiguration';
import {
  type MorningConfigurationControl,
  type MorningConfigurationFormValues,
} from '../MorningConfigurationFormSchema';
import { getMorningIntegrationSettings } from './utils';
import { useIntegrationContextProvider } from '../../../../hooks/use-integration-context-provider';

type MorningConfigurationFooterProps = {
  control: MorningConfigurationControl;
};

export const MorningConfigurationFooter: FC<MorningConfigurationFooterProps> = ({ control }) => {
  const { integrationId, configuration: existingConfiguration } = useFetchMorningSettings();
  const updateMorningConfiguration = useModifyConfiguration();
  const { clearSelectedIntegration } = useIntegrationContextProvider();

  const {
    handleSubmit,
    formState: { dirtyFields },
    reset,
  } = useFormContext<MorningConfigurationFormValues>();

  const { apiKey: isApiKeyDirty, ...formDirtyValues } = dirtyFields;


  const getUpdateMorningConfigurationPromise = async (formValues: MorningConfigurationFormValues) => {
    if (isEmptyObject(formDirtyValues)) {
      return undefined;
    }

    const existingIntegrationSettings = getMorningIntegrationSettings(existingConfiguration);
    const updatedIntegrationSettings = getMorningIntegrationSettings(formValues);

    return updateMorningConfiguration(integrationId, updatedIntegrationSettings, existingIntegrationSettings);
  };

  const submitHandler = handleSubmit(async (formValues) => {
    await getUpdateMorningConfigurationPromise(formValues);

    reset(formValues);

    clearSelectedIntegration();
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler}>
        Save Configuration
      </Button>
    </div>
  );
};